import React from 'react';
import { X, Users, Lock, Video, Image as ImageIcon } from 'lucide-react';

export const GuestAccessModal = ({ guest, subevents, mediaFiles, onClose, onToggleInvite, onToggleMedia, OnSave }) => {
  if (!guest) return null;

  const privateMedia = (mediaFiles || []).filter(
    (m) => !(m.media_type === "user_public" || m.is_public)
  );

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 p-0 backdrop-blur-sm md:items-center md:p-4">
      <div className="relative max-h-[88vh] w-full overflow-y-auto rounded-t-[30px] bg-white p-4 shadow-2xl md:max-w-xl md:rounded-[50px] md:p-10">
        <div className="mx-auto mb-3 h-1.5 w-12 rounded-full bg-gray-200 md:hidden" />
        
        <div className="mb-5 flex items-start justify-between gap-4 md:mb-8">
          <div>
          <span className="px-3 py-1 bg-purple-100 text-purple-600 rounded-full text-[10px] font-black uppercase">Personalized Access</span>
            <h3 className="mt-2 text-xl font-black text-gray-900 md:text-3xl">Personalize {guest.guest.guest_name}</h3>
            <p className="mt-2 text-xs font-semibold leading-5 text-gray-400 md:text-sm">
              Leave unchanged if this guest should receive the standard invite.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-gray-100 p-2.5 text-gray-500 transition hover:bg-gray-950 hover:text-white md:p-3"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="space-y-5 md:max-h-[500px] md:space-y-8 md:overflow-y-auto md:pr-2">
          {/* Subevent Section */}
          <div>
            <h4 className="mb-3 flex items-center gap-2 text-[11px] font-black uppercase text-gray-400 md:mb-4"><Users size={14}/> Event Access</h4>
            <div className="grid gap-2">
              {subevents.length === 0 && (
                  <p className="rounded-3xl bg-gray-50 p-4 text-sm font-semibold text-gray-400 md:p-5">
                  No separate ceremonies or chapters were found for this event.
                </p>
              )}
              {subevents.map(sub => {
                const accessIds = sub.access_ids || [sub.id];
                const isSelected = accessIds.every((subeventId) =>
                  guest.subevent_links?.some((link) => String(link.subevent_id) === String(subeventId))
                );

                return (
                <label key={sub.id} className="flex cursor-pointer items-center justify-between rounded-3xl border-2 border-transparent bg-gray-50 p-4 hover:border-pink-200 md:p-5">
                  <span className="font-bold text-gray-700">
                    {sub.title}
                    {sub.linked_page_count > 0 ? (
                      <span className="mt-1 block text-[10px] font-black uppercase tracking-widest text-gray-400">
                        Includes {sub.linked_page_count} linked page{sub.linked_page_count === 1 ? "" : "s"}
                      </span>
                    ) : null}
                  </span>
                  <input 
                    type="checkbox" 
                    checked={isSelected} 
                    onChange={() => onToggleInvite(accessIds, !isSelected)} 
                    className="w-6 h-6 accent-[#ff0099]" 
                  />
                </label>
                );
              })}
            </div>
          </div>

          {/* Media Section */}
          <div>
            <h4 className="mb-3 flex items-center gap-2 text-[11px] font-black uppercase text-gray-400 md:mb-4"><Lock size={14}/> Private Chapters</h4>
            <div className="grid gap-2">
              {privateMedia.length === 0 && (
                  <p className="rounded-3xl bg-gray-50 p-4 text-sm font-semibold text-gray-400 md:p-5">
                  No private media has been uploaded yet.
                </p>
              )}
              {privateMedia.map((m) => (
                <label key={m.id} className="flex cursor-pointer items-center justify-between rounded-3xl border-2 border-transparent bg-gray-50 p-4 hover:border-purple-200 md:p-5">
                  <div className="flex items-center gap-3">
                    <span className="text-purple-500">{m.file_type?.includes('video') ? <Video size={18}/> : <ImageIcon size={18}/>}</span>
                    <span className="font-bold text-gray-700">{m.name}</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={guest.media_permissions?.some(p => p.media?.id === m.id)} 
                    onChange={() => onToggleMedia(m.id)} 
                    className="w-6 h-6 accent-purple-600" 
                  />
                </label>
              ))}
            </div>
          </div>
        </div>
        <button onClick={OnSave} className="mt-6 w-full rounded-[25px] bg-gray-900 py-3.5 text-sm font-black text-white md:mt-10 md:rounded-[30px] md:py-5 md:text-xl">Done Fine-Tuning</button>
      </div>
    </div>
  );
};
